


























import {Component, Prop, Vue} from 'vue-property-decorator'
import Dropzone from '@/components/Dropzone.vue'

@Component({
  components: {Dropzone},
})
export default class DropzoneOrChooseFile extends Vue {
  @Prop({type: String, default: null}) allowedFileTypes!: string | null
  @Prop({type: String}) message?: string
  @Prop({type: Boolean, default: true}) asImage!: boolean

  get dropMessage() {
    if (this.message) {
      return this.message
    } else if (this.asImage) {
      return this.$t('app.dropFilesImageOr')
    }

    return this.$t('app.dropFilesOr')
  }

  get readableAllowedFileTypes() {
    return this.allowedFileTypes?.replace(/,/g, ', ')
  }

  async chooseFile() {
    const files = await this.$file.promptForMultipleFiles(this.allowedFileTypes)

    if (files) {
      this.$emit('file', files)
    }
  }
}
